import { CmsApiRandomGradProgramsBlockData } from 'modules/cms/api/types/blocks/CmsApiRandomGradProgramsBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';

import { CmsAmpRandomGradProgramsBlock } from './CmsAmpRandomGradProgramsBlock';
import { CmsRandomGradProgramsBlock } from './CmsRandomGradProgramsBlock';

export const CmsRandomGradProgramsBlockMapping: CmsBlockMapping<CmsApiRandomGradProgramsBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsRandomGradProgramsBlock,

    AmpComponent: CmsAmpRandomGradProgramsBlock,
  };
